export default [
  {
    header: 'MAIN FUNCTIONS',
    action: 'read',
    resource: 'basic',
  },
  {
    title: '儀表板',
    route: 'dashboard',
    icon: 'HomeIcon',
    // acl: {
    action: 'read',
    resource: 'staff',
    // },
  },
   {
    title: '學生儀表板',
    route: 'student-dashboard',
    icon: 'HomeIcon',
    // acl: {
    action: 'read',
    resource: 'student',
    // },
  },
  
  {
    title: '學生列表',
    route: 'student-list',
    icon: 'UsersIcon',
    // acl: {
    action: 'read',
    resource: 'staff',
    // },
  },
  {
    // title: 'Center Schedule',
    // route: 'calendar',
    // icon: 'CalendarIcon',
    // // acl: {
    // action: 'read',
    // resource: 'basic',
    // // },
  },
  {
    title: '課堂時間表',
    route: 'class-list',
    icon: 'TrelloIcon',
    // acl: {
    action: 'read',
    resource: 'staff',

    // },
  },

  {
    header: 'Report',
    action: 'read',
    resource: 'staff',
  },
  {
    title: '每日銷售',
    icon: 'PieChartIcon',
    route: 'report',
    action: 'read',
    resource: 'staff',
  },
  {
    title: '分校銷售',
    icon: 'PieChartIcon',
    route: 'report-center-sales',
    action: 'read',
    resource: 'admin',
  },

  {
    title: '付款方式',
    icon: 'PieChartIcon',
    route: 'reportPaymentMethod',
    action: 'read',
    resource: 'admin',
  },


  {
    title: '交易列表',
    icon: 'PieChartIcon',
    route: 'report-transacion',
    action: 'read',
    resource: 'staff',

  },
  {
    title: '到期學生',
    icon: 'PieChartIcon',
    route: 'report-expire-student',
    action: 'read',
    resource: 'staff',
  },
  {
    title: '未付交易',
    icon: 'PieChartIcon',
    route: 'report-nonpay',
    action: 'read',
    resource: 'staff',
  },


  {
    title: '產品',
    icon: 'PieChartIcon',
    route: 'report-product',
    action: 'read',
    resource: 'staff',
  },

  { title: '進階報表',
    icon: 'PieChartIcon',
     action: 'read',
    resource: 'staff',
    children: [
      {
        title: '班別收入',
        icon: 'PieChartIcon',
        route: 'report-class-income',
        action: 'read',
        resource: 'staff',
      },
      {
        title: '學生級別分析',
        icon: 'PieChartIcon',
        route: 'report-student',
        action: 'read',
        resource: 'staff',
      },
      {
        title: '每月營業額',
        route: 'report-sales-monthly',
        action: 'read',
        resource: 'staff',
      },
      {
        title: '試堂及新生',
        route: 'report-trial-and-newjoin',
        action: 'read',
    resource: 'admin',
      },
      {
        title: '老師',
        route: 'report-teacher',
        action: 'read',
        resource: 'basic',
      },
      {
        title: '職員銷售分析',
        route: 'report-user-commission',
        action: 'read',
        resource: 'staff',
      },
      {
        title: '拆學費',
        route: 'report-split',
        action: 'read',
        resource: 'admin',
      },
      {
        title: 'Tags',
        route: 'report-group',
        action: 'read',
        resource: 'admin',
      },
      {
        title: '網上付款',
        route: 'report-online-payment',
        action: 'read',
        resource: 'manager',
      },
      {
        title: '興趣班報名',
        route: 'report-interest-class',
        action: 'read',
        resource: 'admin',
      },
    ],
  },

  {
    header: 'System Config',
    action: 'read',
    resource: 'staff',
  },
  {
    title: '課堂匯入',
    route: 'class-import',
    icon: 'TerminalIcon',
    // acl: {
    action: 'read',
    resource: 'class',
    resource: 'staff',


    // },
  },
  {
    title: '職員列表',
    route: 'staff-list',
    icon: 'LockIcon',
    // acl: {
    action: 'read',
    resource: 'admin',
    // },
  },
  // {
  //   title: 'Room',
  //   route: 'room-list',
  //   icon: 'TrelloIcon',
  //   // acl: {
  //   action: 'read',
  //   resource: 'admin',
  //   // },
  // },
  {
    title: '貨品列表',
    route: 'product-list',
    icon: 'ArchiveIcon',
    // acl: {
    action: 'read',
    resource: 'admin',
    // },
  },
  {
    title: 'App Slider',
    route: 'slider',
    icon: 'ArchiveIcon',
    // acl: {
    action: 'read',
    resource: 'admin',
    // },
  },
  {
    title: '短期課程',
    route: 'short-course-list',
    icon: 'TrelloIcon',
    // acl: {
    action: 'read',
    resource: 'admin',
    // },
  },
  {
    title: '分組列表',
    route: 'group-list',
    icon: 'TagIcon',
    action: 'read',
    resource: 'admin',

  },
  {
    title: '組合列表',
    route: 'product-set-list',
    icon: 'TagIcon',
    action: 'read',
    resource: 'admin',

  },
  {
    title: '課程優惠',
    route: 'offer-list',
    icon: 'TagIcon',
    action: 'read',
    resource: 'admin',
  },
  {
    title: '目標',
    route: 'goal',
    icon: 'TagIcon',
    action: 'read',
    resource: 'admin',
  },

]
